import { $api } from "../../../../../services/request.config";

export const downloadKnowledgeFileThunkAction = (url) => async(dispatch) => {
    try {
        const file = await $api(`${url}`, { responseType: "blob" });
        const blobLink = URL.createObjectURL(
            new Blob([file.data], { type: `${file.headers["content-type"]}` }),
        );
         window.open(blobLink);
    } catch (e) {
        console.error("Ошибка при скачивании документа:", e);
    }
};
